import * as actionTypes from "../actionTypes";

const initialState = {
  showAppTitle: false,
  showMaintasks: true,
  showSidebar: false,
  disableLaunchpad: false,
  bosServerUnavailable: false,
  appIdle: false,
  uiLanguageIsoCode: "de",
  dataViewLanguageIsoCode: "de",
  persistIn: "session"
};

export default function appStateReducer(state = initialState, action) {
  let data = action.data;
  switch (action.type) {
    case actionTypes.SET_SHOW_APPTITLE:
      return {
        ...state,
        showAppTitle: data
      };
    case actionTypes.SET_SHOW_MAINTASKS:
      return {
        ...state,
        showMaintasks: data
      };
    case actionTypes.SET_SHOW_SIDEBAR:
      return {
        ...state,
        showSidebar: data
      };
    case actionTypes.SET_DISABLE_LAUNCHPAD:
      return {
        ...state,
        disableLaunchpad: data
      };
    case actionTypes.SET_BOSSERVER_UNAVAILABLE:
      return {
        ...state,
        bosServerUnavailable: data
      };
    case actionTypes.SET_APPLICATION_IDLE:
      return {
        ...state,
        appIdle: data
      };
      case actionTypes.SET_UILANGUAGE:
        return {
          ...state,
          uiLanguageIsoCode: data,
        };
      case actionTypes.SET_DATAVIEWLANGUAGE:
        return {
          ...state,
          dataViewLanguageIsoCode: data,
        };
    default:
      return state;
  }
}
